import React, { useState } from "react";
import ReactSlider from "react-slider";
import ActivityImage from "../ActividadesUtils/ActImage";
import ImagenValidada from "../ActividadesUtils/RecursosValidados/ImagenValidada";
import VideoValidado from "../ActividadesUtils/RecursosValidados/VideoValidado";
import PlaceholderMedia from "../../PlaceholderMedia";

function BarSlider({ data, instrucciones, isGeneratingPDF = false }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Solo mostrar placeholder si se pasa explícitamente isGeneratingPDF
  const reemplazarRecursos = new URLSearchParams(window.location.search).get('reemplazarRecursos') === 'true';

  const orderedData = [...data].sort((a, b) => (a.orden > b.orden ? 1 : -1));

  // En modo PDF, el carrusel interactivo solo deja ver (y por lo tanto
  // capturar) la diapositiva actual: aquí se listan todos los elementos uno
  // debajo del otro para que ninguno se pierda en el documento estático.
  // Sin aspect-ratio ni object-cover: la imagen se muestra completa, a su
  // proporción natural, sin recortarse. "carrusel-pdf-items" marca el
  // contenedor para que cada diapositiva (imagen + texto) se pagine como una
  // sola pieza y nunca se separen entre páginas distintas.
  if (isGeneratingPDF) {
    return (
      <>
        <div className="lg:mt-8"></div>
        {instrucciones && (
          <div className="block-instructions mt-10 mb-4">{instrucciones}</div>
        )}
        <div className="w-full carrusel-pdf-items">
          {orderedData.map((item, index) => (
            <div key={index} className="mb-8">
              {item.imagen && (
                <ImagenValidada
                  className="w-full max-w-md mx-auto rounded-lg mb-2 bg-[#f6fcff]"
                  src={item.imagen}
                />
              )}
              {(item.video || item.audio) && (
                <PlaceholderMedia
                  tipo={item.video ? "video" : "audio"}
                  nombreArchivo={reemplazarRecursos ? (item.video || item.audio) : null}
                />
              )}
              {item.texto && (
                <div className="font-bold text-nimbusLight text-justify">{item.texto}</div>
              )}
            </div>
          ))}
        </div>
      </>
    );
  }

  return (
    <>
      <div className="lg:mt-8"></div>
      {instrucciones && (
        <div className="block-instructions mt-10 mb-4">{instrucciones}</div>
      )}
      <div className="flex items-center justify-between mb-10">
        <div className="flex flex-1 justify-center align-center">
          <ReactSlider
            className="vertical-slider"
            marks
            markClassName="slider-mark"
            min={0}
            max={orderedData.length - 1}
            onAfterChange={(e) => setCurrentSlide(e)}
            thumbClassName="slider-thumb"
            trackClassName="slider-track"
            orientation="vertical"
            pearling
            renderThumb={(props, state) => (
              <div {...props}>{state.valueNow + 1}</div>
            )}
          />
        </div>
        <div className="w-full max-w-[50rem]">
          {orderedData[currentSlide]?.imagen && (
            <ImagenValidada
              className="w-full rounded-lg mb-4 aspect-video object-cover overflow-hidden bg-[#f6fcff]"
              src={orderedData[currentSlide]?.imagen}
            />
          )}
          {orderedData[currentSlide]?.video && (
            <VideoValidado
              className="w-full rounded-lg mb-4 aspect-video object-cover overflow-hidden bg-[#f6fcff]"
              src={orderedData[currentSlide]?.video}
              key={orderedData[currentSlide]?._id}
            />
          )}
          {orderedData[currentSlide]?.texto && (
            <div className="font-bold text-nimbusLight text-justify min-h-[120px]">
              {orderedData[currentSlide]?.texto}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

BarSlider.defaultProps = {
  slidesLength: 4,
};

export default BarSlider;
